
<app-add-todo (addTodo)="addTodo($event)"></app-add-todo>
<app-todo-item 
    *ngFor="let todo of todos" 
    [todo]="todo"
    (deleteTodo)="deleteTodo($event)"
    >
</app-todo-item>